<div class="title" l10nTranslate>shared.attachments</div>
<div>
  <ul>
    <li *ngFor="let attachment of ticketDetail.attachments">
      <miq-attachment [attachment]="attachment"></miq-attachment>
    </li>
  </ul>
</div>
<div class="desc" *ngIf="!ticketDetail.attachments" l10nTranslate>shared.noAttachmentsAvailble</div>
